import SignInPage from './SignInPage';
import { SignInPageProps, SignInPageValueProps } from './types';

export type { SignInPageProps, SignInPageValueProps };
export default SignInPage;
